import MDLPerson from './MDLPerson/MDLPerson';
import './MDLPersons.scss'
import { Person } from './person';

function MDLPersons(props: {persons: Person[]}) {
  const {persons} = props;

  return <div className="mdl-persons">
    {persons.map((person: Person) => {
      return <MDLPerson imgPath={person.imgPath} firstName={person.firstName} lastName={person.lastName} title={person.title} role={person.role} email={person.email}></MDLPerson>;
    })}
  </div>
}

export default MDLPersons;